export default (selector, func) => {
  $(selector).on('ajax:complete', function(event) {
    const responseJSON = JSON.parse(event.detail[0].responseText)
    const status = JSON.parse(event.detail[0].responseText)

    return func(responseJSON, status)
  })
}
